import { createSearchParams, useNavigate } from "react-router-dom";

// Constants
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";

// Icons
import Search from "assets/icons/search.svg?react";

import "./styles.sass";

const GameSearchButton = () => {
  const navigate = useNavigate();

  const handleSearchClick = (e) => {
    e.preventDefault();
    navigate({
      search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.gameSearch })}`,
    });
  };

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <button
      type="button"
      className="GameSearchButton"
      onClick={handleSearchClick}
    >
      <Search />
    </button>
  );
};

export default GameSearchButton;
